import { DEVICE, ROUTES } from '@/utils/constants';

const normalizePathname = (pathname: string): string => {
    if (!pathname || pathname === '/') {
        return '/';
    }
    const trimmed = pathname.replace(/\/+$/, '');
    return trimmed === '' ? '/' : trimmed;
};

const isMobileServerRequest = (input: {
    platformCookie: string | undefined;
    userAgent: string | undefined;
    secChUaMobile: string | undefined;
}): boolean => {
    const { platformCookie, userAgent, secChUaMobile } = input;
    if (platformCookie === DEVICE.DESKTOP) {
        return false;
    }
    if (platformCookie !== DEVICE.DESKTOP) {
        return true;
    }
    if (secChUaMobile === '?1') {
        return true;
    }
    if (userAgent && /Mobile|Android|iPhone|iPod|IEMobile|webOS|BlackBerry/i.test(userAgent)) {
        return true;
    }
    return false;
};

const headerHidePathnames = new Set([ROUTES.REWARDS, ROUTES.BONUS_SPINS_DETAILS]);

const headerHidePrefixes = [ROUTES.GAMEPLAY_SESSION];

/** Routes where the header should only be hidden on iOS (visible on Android and web). */
const iosOnlyHidePathnames = new Set([ROUTES.REWARD_MACHINE_EXIT, ROUTES.REWARD_MACHINE_INFO]);

export const matchesHeaderHidePathname = (pathname: string, isIos = false, isIosWrapper = false): boolean => {
    const normalized = normalizePathname(pathname);

    if (ROUTES.MOMENTUM === normalized && isIosWrapper) {
        return true;
    }

    if (iosOnlyHidePathnames.has(normalized)) {
        return isIos;
    }

    if (headerHidePathnames.has(normalized)) {
        return true;
    }

    return headerHidePrefixes.some((prefix) => pathname.startsWith(prefix));
};

/** Server: whether initial `<body>` should include `header-hidden` / `ribbon-hidden` for the current route (request). */
export const shouldHideHeaderOnRoute = (input: {
    pathname: string;
    platformCookie: string | undefined;
    userAgent: string | undefined;
    secChUaMobile: string | undefined;
    isIos: boolean;
    isIosWrapper: boolean;
}): boolean => {
    const { pathname, isIos, isIosWrapper, ...mobileInput } = input;
    const isNarrowDevice = isMobileServerRequest(mobileInput);

    if (!isNarrowDevice) {
        return false;
    }

    return matchesHeaderHidePathname(pathname, isIos, isIosWrapper);
};
